// @ts-nocheck
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export default function AddFunctionDialog({ open, onOpenChange, onCreateCustomApi }: any) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-primary">Add Function</DialogTitle>
          <DialogDescription>
            Functions let the agent connect with other systems to get data or take action. Add
            one from a connected toolkit, or a built-in.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3">
          <Button
            type="button"
            variant="outline"
            className="w-full justify-center text-primary"
            onClick={() => {
              onOpenChange(false);
              onCreateCustomApi();
            }}
          >
            <Plus className="h-4 w-4" />
            Create Custom API
          </Button>
{/* 
          <p className="py-4 text-center text-sm text-muted-foreground">No functions available.</p> */}
        </div>

        {/* <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            Done
          </Button>
        </DialogFooter> */}
      </DialogContent>
    </Dialog>
  );
}